export default function queryHasArray (query, queryStringKey) {
  return Boolean(Object.entries(query).filter(([key]) => {
    return key.startsWith(`${queryStringKey}[`)
  }).length)
}
